import { FinanceSimulationCalculator } from '../../components/finance-simulation-calculator';
import React from 'react';

export const FinanceSimulationPage: React.FC = () => {
    return <FinanceSimulationCalculator />;
};
